import { createContext, useContext, FC, ReactNode } from "react";
import { useAuth, UseAuthReturn } from "../hooks/useAuth";

// Create context for auth
const AuthContext = createContext<UseAuthReturn | null>(null);

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within AuthProvider");
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
  const auth = useAuth();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
